import { Injectable, signal } from '@angular/core';
import { finalize, Observable, of } from 'rxjs';

import { RegistrationStepForm } from '../types';

/**
 * Holds a reference to the step form currently rendered in the wizard outlet.
 * Step components register themselves on init and clear on destroy, letting the
 * wizard trigger submit/save on the active step without tight coupling.
 */
@Injectable({ providedIn: 'root' })
export class RegistrationStepRegistry {
  readonly savingCurrentStep = signal(false);
  readonly submittingCurrentStep = signal(false);

  private activeStep: RegistrationStepForm | null = null;

  register(stepForm: RegistrationStepForm | null): void {
    this.activeStep = stepForm;

    if (!stepForm) {
      this.savingCurrentStep.set(false);
      this.submittingCurrentStep.set(false);
    }
  }

  submitCurrentStep(): Observable<boolean> {
    if (!this.activeStep) {
      return of(true);
    }

    if (this.submittingCurrentStep()) {
      return of(false);
    }

    this.submittingCurrentStep.set(true);

    return this.activeStep.submit().pipe(
      finalize(() => this.submittingCurrentStep.set(false)),
    );
  }

  saveCurrentStep(): Observable<boolean> {
    if (!this.activeStep) {
      return of(true);
    }

    if (this.savingCurrentStep()) {
      return of(false);
    }

    this.savingCurrentStep.set(true);

    return this.activeStep.save().pipe(
      finalize(() => this.savingCurrentStep.set(false)),
    );
  }
}
